import { render } from "./Index.vue?vue&type=template&id=76e31e7a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=76e31e7a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/thadmin/thadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e31e7a"]])

export default __exports__